import React from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from '../common/ConfirmDialog';
import { getWord } from '../utils/tenant';
import QueueModal from './QueueModal';
import { hot } from 'react-hot-loader';
import { NotificationCenter } from '../utils/types';
import css from './BulkActionConfirm.scss';
import { fetchAuthenticatedJSON, urlParams } from '../utils/request';

class BulkActionConfirm extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      isConfirmDialogOpen: true,
      isModalOpen: false,
      isCancelBatchAction: false,
      createdTenantJobId: -1
    };
  }
  
  componentDidMount() {
    this.props.notificationCenter.addListener('batchactionsent', this.batchActionCreated);
  }

  componentWillUnmount() {
    this.props.notificationCenter.removeListener('batchactionsent', this.batchActionCreated);
  }

  /**
   * CONFIRMATION POPUP
   */
  get buttonMessage() {
    switch (this.props.action) {
      case 'comment':
        return `You are about to ${this.actionName} on ${this.props.totalActions} ${getWord('tracker', true)} items.`;
      case 'message':
        return `You are about to send a ${this.actionName} to ${this.props.totalActions} students.`;
      case 'flag':
        return `You are about to raise a ${this.actionName} on ${this.props.totalActions} students.`;
      case 'referral':
        return `You are about to create a ${this.actionName} for ${this.props.totalActions} students.`;
      case 'to_do':
        return `You are about to create a ${this.actionName} for ${this.props.totalActions} students.`;
      case 'kudo':
        return `You are about to create a ${this.actionName} for ${this.props.totalActions} students.`;
      case 'success-plan':
        return `You are about to add a ${this.actionName} for ${this.props.totalActions} students.`;
      case 'note':
        return `You are about to create a ${this.actionName} for ${this.props.totalActions} students.`;
      case 'resolve':
        return `You are about to create a ${this.actionName} for ${this.props.totalActions} ${getWord('tracker', true)} items.`;
      case 'assign':
        return `You are about to create an ${this.actionName} for ${this.props.totalActions} ${getWord('tracker', true)} items.`;
    }
  }

  returnToActionWindow = () => {
    this.setState({ isConfirmDialogOpen: false });
    this.props.returnToActionWindow();
  }
  
  save = () => {
    this.props.saveAction();
    // move to confirmation screen
    this.setState({ isConfirmDialogOpen: false, isModalOpen: true });
  }

  /**
   * CONFIRMATION SCREEN
   */
  // display the confirmation modal
  confirmCancellation = () => {
    this.setState({ isModalOpen: false, isConfirmDialogOpen: false, isCancelBatchAction: true });
  }

  // saves the batch action and navigates to the dashboard.
  seeItemsInQueue = () => {
    window.location.assign("../instructor/index.html#batchSentItems")
  }

  /**
   * CANCEL POPUP
   */
  // gets description text for Cancel dialog when user cancels the batch action
  get cancelPopupDescriptionText() {
    switch (this.props.action) {
      case 'comment':
        return `You are about to cancel your ${this.actionName} on ${this.props.totalActions} ${getWord('tracker', true)} items.`;
      case 'message':
        return `You are about to cancel your ${this.actionName} to ${this.props.totalActions} students.`;
      case 'flag':
        return `You are about to cancel your ${this.actionName} on ${this.props.totalActions} students.`;
      case 'referral':
        return `You are about to cancel your ${this.actionName} for ${this.props.totalActions} students.`;
      case 'to_do':
        return `You are about to cancel your ${this.actionName} for ${this.props.totalActions} students.`;
      case 'kudo':
        return `You are about to cancel your ${this.actionName} for ${this.props.totalActions} students.`;
      case 'success-plan':
        return `You are about to cancel your ${this.actionName} for ${this.props.totalActions} students.`;
      case 'note':
        return `You are about to cancel your ${this.actionName} for ${this.props.totalActions} students.`;
      case 'resolve':
        return `You are about to cancel your ${this.actionName} of ${this.props.totalActions} ${getWord('tracker', true)} items.`;
      case 'assign':
        return `You are about to cancel your ${this.actionName} of ${this.props.totalActions} ${getWord('tracker', true)} items.`;
    }
  }

  /**
   * COMMON FUNCTIONS
   */
  close = () => {
    this.setState({
      isConfirmDialogOpen: false,
      isModalOpen: false,
      isCancelBatchAction: false
    });
  }
  
  closeWithNotification = () => {
    this.props.notificationCenter.fireEvent('batchactioncount');
    this.close();
  }

  get actionName() {
    switch (this.props.action) {
      case 'comment':
        return "comment";
      case 'message':
        return "message";
      case 'flag':
        return "flag";
      case 'referral':
        return "referral";
      case 'to_do':
        return "to-do";
      case 'kudo':
        return getWord('kudos', true);
      case 'success-plan':
        return "success plan";
      case 'note':
        return "note";
      case 'resolve':
        return "resolution";
      case 'assign':
        return "assignment";
    }
  }

  cancel = () => {
    fetchAuthenticatedJSON('../batchAction/cancel.html', {
      method: 'POST',
      body: urlParams({
        tenantJobId: this.state.createdTenantJobId
      })
    });
    this.props.notificationCenter.fireEvent("batchactionsenttoast");
    this.close();		
  }

  batchActionCreated = (createdTenantJobId) => {
    this.setState({ createdTenantJobId })
  }

  render() {
    return (
      <>
        <ConfirmDialog
          confirmText="Yes, Finish"
          headerText="Are you sure about that?"
          descriptionText={this.buttonMessage}
          onClose={this.returnToActionWindow}
          onConfirm={this.save}
          isOpen={this.state.isConfirmDialogOpen}
        />
        <QueueModal
          isOpen={this.state.isModalOpen}
          onEscape={this.closeWithNotification}
          onSeeItemsInQueue={this.seeItemsInQueue}
          onBackToStudentList={this.closeWithNotification}
          onCancelBatchAction={this.confirmCancellation}
          totalActions={this.props.totalActions}
          actionName={this.actionName}
        />
        <ConfirmDialog
          confirmText="Yes, Cancel"
          headerText="Are you sure you want to cancel the batch send job?"
          descriptionText={this.cancelPopupDescriptionText}
          cancelText="No, Keep Sending"
          onClose={this.closeWithNotification}
          onConfirm={this.cancel}
          isOpen={this.state.isCancelBatchAction}
          className={css['batch-cancel-modal']}
        />
      </>
    );
  }
}

BulkActionConfirm.propTypes = {
  action: PropTypes.oneOf(['comment', 'message', 'flag', 'referral', 'to_do', 'kudo', 'success-plan', 'note', 'resolve', 'assign']).isRequired,
  totalActions: PropTypes.number.isRequired,
  saveAction: PropTypes.func.isRequired,
  returnToActionWindow: PropTypes.func.isRequired,
  notificationCenter: NotificationCenter.isRequired,
};

export default hot(module)(BulkActionConfirm);
